export default class ApplicationAttributes {
  role: string = "mentor"
  howDidYouHearAboutUs: string
  howDidYouHearAboutUsOther: string
  program: string
  search: string
  firstName: string
  lastName: string
  email: string
  phone: string
  call: boolean = false
  sms: boolean = false
  status: string
  created
  createdDisplay
  relayEmail
  programTitle
  searchId
  programId

  constructor(newApplication = false) {
    if(newApplication) {
      this.firstName = localStorage.getItem('firstName')
      this.lastName = localStorage.getItem('lastName')
      this.phone = localStorage.getItem('phone')
      this.email = localStorage.getItem('email')
      this.call = localStorage.getItem('call') == 'true'
      this.sms = localStorage.getItem('sms') == 'true'
    }
  }

  serialize(): any {
    localStorage.setItem('firstName', this.firstName)
    localStorage.setItem('lastName', this.lastName)
    localStorage.setItem('email', this.email)
    localStorage.setItem('phone', this.phone)
    localStorage.setItem('call', this.call ? 'true' : 'false')
    localStorage.setItem('sms', this.sms ? 'true' : 'false')
    return {
      role: this.role,
      how: this.howDidYouHearAboutUs,
      howOther: this.howDidYouHearAboutUsOther,
      firstName: this.firstName,
      lastName: this.lastName,
      email: this.email,
      phone: this.phone,
      call: this.call,
      sms: this.sms,
      searchId: this.searchId,
      programId: this.programId
    }
  }

}
